
import Button from '../../../components/base/Button';

export default function PartnerCTASection() {
  return (
    <section className="section-wrap bg-gradient-to-br from-[#2D7F3E] to-[#1A5A2A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-heading text-white">
            Ready to Partner With Excellence?
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Join the thousands of individuals and organisations who have chosen Sylman Academy 
            as their trusted partner in skills development and transformation. Let's build 
            something extraordinary together.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              size="lg" 
              className="!bg-white !text-[#2D7F3E] hover:!bg-gray-100 text-lg"
            >
              <i className="ri-phone-line mr-2"></i>
              Contact Us Today
            </Button>
            <Button 
              variant="ghost"
              size="lg" 
              className="border-white text-white hover:bg-white hover:text-[#2D7F3E] text-lg"
            >
              <i className="ri-download-line mr-2"></i>
              Download Brochure
            </Button>
          </div>

          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white/90">
            <div className="flex flex-col items-center gap-2">
              <i className="ri-phone-line text-2xl"></i>
              <div className="font-semibold">Call Us</div>
              <div>+27 10 224 0406</div>
            </div>
            <div className="flex flex-col items-center gap-2">
              <i className="ri-mail-line text-2xl"></i>
              <div className="font-semibold">Email Us</div>
              <div>info@sylman.co.za</div>
            </div>
            <div className="flex flex-col items-center gap-2">
              <i className="ri-map-pin-line text-2xl"></i>
              <div className="font-semibold">Visit Us</div>
              <div>No 6 Riboville Road, 183 Randjesfontein Country Estate, Midrand</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
